import React from 'react';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const EmptyState = () => {
  const t = useTranslation();

  return (
    <div className="empty-description-wrapper">
      <div className="empty-description">
        <i className="global-icon icon-empty" />
        <p>{t('There are no data for the selected time period')}</p>
      </div>
    </div>
  );
};

export default EmptyState;
